import React, { useState } from 'react';

import ModalFooter from 'CommonComponents/ModalFooter';
import ModalHeader from 'CommonComponents/ModalHeader';

export default function AddInputReachCategoryModal(props) {
    const [name, setName] = useState('');

    const internalCloseHandler = () => {
        props.closeHandler();
    };

    const internalSuccessHandler = () => {
        props.successHandler(name);
    };

    return (
        <div id={props.modalId} ref={props.modalRef} tabIndex="-1" aria-hidden="true" className="hidden modal__box">
            <div className="modal__container">
                <div className="modal__inner-container">
                    <ModalHeader title="Add new Category" close={internalCloseHandler}></ModalHeader>
                    <div className="tw-rounded-b">
                        {props.name != '' && (
                            <div className="modal__form-container">
                                <div className="tw-grid tw-grid-cols-1">
                                    <div className="tw-flex tw-flex-col tw-space-y-1.5">
                                        <label className="text-input__label">Category name</label>
                                        <input
                                            className={'tw-border-0 text-input'}
                                            type={'text'}
                                            value={name}
                                            placeholder={'Enter category name'}
                                            onChange={(e) => {
                                                setName(e.target.value);
                                            }}
                                        />
                                    </div>
                                </div>
                                <ModalFooter
                                    cancelButtonText={$t('Cancel')}
                                    primaryButtonText={$t('OK')}
                                    onCancel={internalCloseHandler}
                                    handleSubmit={internalSuccessHandler}
                                ></ModalFooter>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
